import React from 'react';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import type { ImportType } from '../../../common/constants/import-type';
import { useGuide } from './utils';

export const Guide = ({ importType }: { importType?: ImportType }) => {
	const guide = useGuide(importType);

	if (guide === null) {
		return null;
	}

	const { heading, steps } = guide;

	return (
		<Stack
			xcss={wrapperStyles}
			testId="project-create-importer-upload-flow.ui.upload-screen-standard.guide.stack"
		>
			<Box as="h4" xcss={headingStyles}>
				{heading}
			</Box>
			<Box as="ul" xcss={listStyles}>
				{steps.map((step, index) => (
					<Box as="li" key={index} xcss={listItemStyles}>
						<Box xcss={circleStyles}>{index + 1}</Box>
						<Box as="p" xcss={stepStyles}>
							{step}
						</Box>
					</Box>
				))}
			</Box>
		</Stack>
	);
};

const wrapperStyles = xcss({
	marginBlockStart: 'space.400',
});

const headingStyles = xcss({
	color: 'color.text',
	font: token('font.heading.xsmall'),
});

const listStyles = xcss({
	listStyle: 'none',
	padding: 'space.0',
	marginBlockStart: 'space.200',
});

const listItemStyles = xcss({
	display: 'flex',
	gap: 'space.200',
	paddingBlockEnd: 'space.100',
	font: token('font.body'),
	color: 'color.text.subtle',
});

const circleStyles = xcss({
	backgroundColor: 'color.background.accent.blue.subtlest',
	borderRadius: 'border.radius.circle',
	height: '24px',
	width: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-around',
});

const stepStyles = xcss({
	marginBlockStart: 'space.025',
});
